<!-- Affichage de la map -->

<div class="map_container" leaflet [leafletOptions]="mapOptions" [leafletMarkerCluster]="markers"></div>

<div class="map-loading" *ngIf="isLoading">
    <div class="spinner"></div>
    <p>{{ 'map.loading.value' | translate }}</p>
</div>

<!-- Affichage du détail d'une offre -->

<ng-container *ngIf="displayedOffer">
    <div class="col_4 card_offer_map">
        <app-core-offer-card
            [item]="displayedOffer"
            [displayLocation]="displayLocation"
            [roles]="roles"
            [layoutView]="layoutView"
            [mode]="mode"
            [identificationNumber]="identificationNumber"
            [publicPrice]="publicPrice"
            (closeItem)="resetDisplayedOffer()"
        ></app-core-offer-card>
    </div>
</ng-container>
